module.exports = __webpack_public_path__ + "cc6263642e5988de222afcedba43fa98.pdf";